import { ElementRef, OnDestroy, } from '@angular/core';
import { MatAnchor, MatButton, } from '@angular/material/button';
import { MatMenuItem } from '@angular/material/menu';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { unsubscribe } from '@utils/object.utils';
import { combineLatest, } from 'rxjs';
var AuthorizeBaseDirective = /** @class */ (function () {
    function AuthorizeBaseDirective(_appState, _hostButton, _hostAnchor, _hostMenuItem, _translateService, element) {
        this._appState = _appState;
        this._hostButton = _hostButton;
        this._hostAnchor = _hostAnchor;
        this._hostMenuItem = _hostMenuItem;
        this._translateService = _translateService;
        this._originalTitle = null;
        this._originalDisplay = null;
        this._disableIf = false;
        this._element = element.nativeElement;
    }
    Object.defineProperty(AuthorizeBaseDirective.prototype, "disableIf", {
        set: function (condition) {
            this._disableIf = condition;
            this._isElementDisabled = condition || !!this._isPermissionDisable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_isElementDisabled", {
        set: function (state) {
            if (state) {
                this._element.setAttribute('disabled', 'true');
            }
            else {
                this._element.removeAttribute('disabled');
            }
            if (this._hostButton) {
                this._hostButton.disabled = state;
            }
            if (this._hostAnchor) {
                this._hostAnchor.disabled = state;
            }
            if (this._hostMenuItem) {
                this._hostMenuItem.disabled = state;
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthorizeBaseDirective.prototype.ngOnDestroy = function () {
        unsubscribe(this._hideSub, this._disableSub);
    };
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permission", {
        set: function (permission) {
            var _this = this;
            if (this._originalDisplay == null) {
                this._originalDisplay = this._element.style.display;
            }
            if (this._hideSub) {
                this._hideSub.unsubscribe();
            }
            this._hideSub =
                this._isGranted(permission).subscribe(function (result) {
                    if (!result) {
                        _this._element.style.display = 'none';
                    }
                    else {
                        _this._element.style.display = _this._originalDisplay;
                    }
                });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permissionDisable", {
        set: function (permission) {
            var _this = this;
            if (this._originalTitle == null) {
                this._originalTitle = this._element.style.display;
            }
            if (this._disableSub) {
                this._disableSub.unsubscribe();
            }
            this._disableSub = combineLatest([
                this._translateService.stream('authorize_no_permissions'),
                this._isGranted(permission),
            ])
                .subscribe(function (_a) {
                var message = _a[0], granted = _a[1];
                _this._isPermissionDisable = !granted;
                if (_this._isPermissionDisable) {
                    _this._element.title = message;
                    _this._isElementDisabled = true;
                }
                else {
                    _this._element.title = _this._originalTitle || '';
                    _this._isElementDisabled = _this._disableIf;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permissionAny", {
        set: function (permissions) {
            this._permission = permissions.join('|');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permissionAnyDisable", {
        set: function (permissions) {
            this._permissionDisable = permissions.join('|');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permissionAll", {
        set: function (permissions) {
            this._permission = permissions.join('&');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeBaseDirective.prototype, "_permissionAllDisable", {
        set: function (permissions) {
            this._permissionDisable = permissions.join('&');
        },
        enumerable: true,
        configurable: true
    });
    return AuthorizeBaseDirective;
}());
export { AuthorizeBaseDirective };
